import { InjectionToken } from '@angular/core';

// https://stackoverflow.com/a/54362206

/**
 * Request the global Window object.
 */
export const WINDOW = new InjectionToken<Window>('Window');

export function windowFactory() {
  return window;
}
